import { initializeApp } from 'firebase/app';
import firebase from "firebase/app";
import { getAuth, EmailAuthProvider, linkWithCredential, updateEmail, deleteUser, reauthenticateWithCredential } from 'firebase/auth';
import { getFirestore, collection, getDocs } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';




// Config is injected at build time via .env.development (sandpit) or .env.production (live).
// npm start → .env.development (camping-buddy-sandpit)
// npm run build → .env.production (camping-buddy-ff446)
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// initialize firebase
const app = initializeApp(firebaseConfig);



export const auth = getAuth();
export const authEmail = EmailAuthProvider;
export const linkCredential =  linkWithCredential;
export const updateFBEmail =  updateEmail;
export const deleteAccount =  deleteUser;
export const reauthenticate = reauthenticateWithCredential;
export const db = getFirestore(app);
export const storage = getStorage(app);
